// formConfig.js
export const FORM_FIELDS = {
  name: { name: 'name', label: 'Nombre', type: 'text' , required: true},
  email: { name: 'email', label: 'Email', type: 'email', required: true },
  phone: { name: 'phone', label: 'Teléfono', type: 'text' , required: true},
};


export const PARTICIPANT_FIELDS = [
  { ...FORM_FIELDS.name, name: 'first_name', label: 'Nombre', required: true },
  { ...FORM_FIELDS.name, name: 'last_name', label: 'Apellidos(Paterno Materno)', required: true },

  { name: 'username', label: 'Email', type: 'text', required: true },
  { ...FORM_FIELDS.email, name: 'personal_email', label: 'Confirma tu email', required: true },

  { name: 'password', label: 'Crea contraseña', type: 'password', required: true },

  { ...FORM_FIELDS.phone, name: 'personal_phone', label: 'Teléfono', required: true },

  { name: 'office_email', label: 'Email Oficina(Opcional)', type: 'email' },
  { name: 'office_phone', label: 'Teléfono Oficina(Opcional)', type: 'text' },

  { name: 'birthdate', label: 'Fecha de nacimiento', type: 'date', required: true },
  { name: 'nationality', label: 'Nacionalidad', type: 'text' },
  { name: 'sex', label: 'Género', type: 'select', required: true },
  { name: 'passport_number', label: 'Número de Pasaporte', type: 'text', required: true },
  { name: 'passport_expNum', label: 'Expiración pasaporte MM/YY', type: 'text', required: true },
  { name: 'snow_activities', label: '¿Realizarás esquí o snowboard?', type: 'select', required: true },
  { name: 'eta', label: '¿Cuentas con eTA vigente?', type: 'select', required: true },
  // { name: 'visa_number', label: 'Visa number', type: 'text', required: true },
];


export const LOGIN_FIELDS = [
  { name: 'username', label: 'ID Correo', type: 'text', required: true },
  { name: 'password', label: 'Contraseña', type: 'password', required: true },
];

export const RECOVERY_FIELDS = [
  { name: 'username', label: 'Introduce tu correo', type: 'email', required: true },
];


export const MOUNTAIN_FIELDS = [
  { name: 'discipline', label: 'Disciplina', type: 'select', required: true },
  { name: 'skill_level', label: 'Nivel de Habilidad', type: 'select', required: true },
  { name: 'height_cm', label: 'Altura (pies)', type: 'select', required: true },
  { name: 'weight_kg', label: 'Peso (libras)', type: 'select', required: true },
  { name: 'shoe_size', label: 'Calzado(US)', type: 'select', required: true },
];

export const EMERGENCY_CONTACT_FIELDS = [
  FORM_FIELDS.name,
  { name: 'relationship', label: 'Parentesco', type: 'select', required: true },
  FORM_FIELDS.phone,
  FORM_FIELDS.email,
];


export const PERSONAL_DATA = [
  { ...FORM_FIELDS.name, name: 'first_name', label: 'Nombre', required: true, readOnly: true },
  { ...FORM_FIELDS.name, name: 'last_name', label: 'Apellido', required: true, readOnly: true },

  { name: 'username', label: 'Email', type: 'text', required: true, readOnly: true },

  { ...FORM_FIELDS.phone, name: 'personal_phone', label: 'Teléfono', required: true, readOnly: true },


  { name: 'birthdate', label: 'Fecha de nacimiento', type: 'date', required: true, readOnly: true },
  { name: 'nationality', label: 'Nacionalidad', type: 'text', readOnly: true },
  { name: 'sex', label: 'Género', type: 'select', required: true, readOnly: true },
  { name: 'passport_number', label: 'Número de Pasaporte', type: 'text', required: true , readOnly: true},
  // { name: 'snow_activities', label: '¿Realizarás esquí o snowboard?', type: 'select', required: true , readOnly: true},
  // { name: 'eta', label: '¿Cuentas con eTA vigente?', type: 'select', required: true, readOnly: true },
  // { name: 'visa_number', label: 'Visa number', type: 'text', required: true },
];

// formConfig.js
